import { createClientQuery } from 'util/createClientQuery';

import { createAsyncThunk } from '@reduxjs/toolkit';
import { serializeError } from 'shared/utils/redux';
import { clientApi } from 'container/clientApi';

import { STORE_NAME } from './initialState';

export const fetchClients = createAsyncThunk(
  `${STORE_NAME}/fetchClients`,
  async ({
    searchText,
    page,
    limit,
    circleId,
  }: {
    searchText: string;
    page: number;
    limit: number;
    circleId?: string;
  }) => {
    const query = createClientQuery({ searchText, page, limit, circleId });

    return clientApi.get(query);
  },
  { serializeError },
);
